<script lang="ts">
    import { browser } from '$app/environment';
    import { initNativeBridge } from '$lib/services/native/index';
    export let gatekeeperInitiated: boolean;
    let setup = false;

    $: if (!setup && browser && gatekeeperInitiated && Boolean(window.native)) {
        initNativeBridge();
        setup = true;
    }
</script>
